<div class="detail-page">
  <div class="detail-page__header" [class.pinned]="isPinChecked">
    <a (click)="goBack()" style="cursor: pointer;"
       mat-button type="button" class="detail-page__back-btn">
      <mat-icon>chevron_left</mat-icon>
      <span class="detail-page__back-text">Back to {{ backLabel }}</span>
    </a>
    <div class="detail-page__pin-search-bar">
      <mat-checkbox class="pin-search-bar" [(ngModel)]="this.isPinChecked" (change)="onChange($event)">Pin search bar</mat-checkbox>
    </div>
    <div class="detail-page__header-main">
    </div>
    <div class="detail-page__search-container">
      <app-autocomplete class="detail-page__search"></app-autocomplete>
    </div>
  </div>
  <div class="detail-page__content-wrapper">
    <app-business-detail [business]="business"></app-business-detail>
  </div>
  <app-app-footer></app-app-footer>
</div>
